import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useAuthStore } from 'src/entities/user/store/useAuthStore';
import { analyticsService } from 'src/services/analytics/analyticsService';
import {
  RFQ_BUILDER_BACK_CLICKED,
  RFQ_BUILDER_LEAVE_DRAFT_CANCELLED,
  RFQ_BUILDER_LEAVE_DRAFT_CONFIRMED
} from 'src/services/analytics/rfqBuilderEvents';
import { ROUTE_PATHS } from 'src/shared/config/routes';

import ImpersonationBanner from 'src/shared/components/ImpersonationBanner';
import { Typography } from 'src/shared/components/ui';

import LeaveDraftModal from './LeaveDraftModal';

const RfqBuilderHeader: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const impersonation = useAuthStore((state) => state.impersonation);
  const headerTopClass = impersonation ? 'top-10' : 'top-0';

  const step = searchParams.get('step');
  const rfqId = searchParams.get('rfq') ?? undefined;
  const hasProgress = step !== null && step !== 'landing';

  const handleBackClick = () => {
    analyticsService.trackEvent(RFQ_BUILDER_BACK_CLICKED, {
      step: step ?? undefined,
      rfq_id: rfqId
    });
    if (hasProgress) {
      setIsModalOpen(true);
    } else {
      navigate(ROUTE_PATHS.PRODUCTS);
    }
  };

  const handleConfirmLeave = () => {
    analyticsService.trackEvent(RFQ_BUILDER_LEAVE_DRAFT_CONFIRMED, {
      step: step ?? undefined,
      rfq_id: rfqId
    });
    setIsModalOpen(false);
    navigate(ROUTE_PATHS.PRODUCTS);
  };

  const handleStay = () => {
    analyticsService.trackEvent(RFQ_BUILDER_LEAVE_DRAFT_CANCELLED, {
      step: step ?? undefined,
      rfq_id: rfqId
    });
    setIsModalOpen(false);
  };

  return (
    <>
      {impersonation && <ImpersonationBanner />}
      <div
        id="back-to-home-link"
        className={`h-16 bg-transparent mobile:bg-white mobile:left-0 mobile:right-0 flex items-center gap-2 px-5 fixed ${headerTopClass} z-[49]`}
      >
        <button
          className="flex items-center gap-2"
          onClick={handleBackClick}
          type="button"
        >
          <ChevronLeftIcon className="size-5" />

          <Typography variant="body-1" weight="bold">
            Back to Home
          </Typography>
        </button>
      </div>

      <LeaveDraftModal
        isOpen={isModalOpen}
        onClose={handleStay}
        onConfirm={handleConfirmLeave}
      />
    </>
  );
};

export default RfqBuilderHeader;
